module.exports = __webpack_public_path__ + "fonts/icomoon.89ed3da.woff";